
export default {
  props: {
    titles: {},
    sortBy: ""
  },
  methods: {
    hanleClick(title) {
      if (title.text) this.$emit("hanldeSort", title);
    }
  }
};
